import React from 'react';

import { flagStyles } from '../settings';

const SvgBR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-696px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBR;
